import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { Status } from '../../../common/constants';
import { getOrganizationsAnalyticsApi } from '../analyticsApi';
import { normalizeOrganizationsAnalyticsResponse } from '../analyticsUtils';

const GET_ORGANIZATIONS_ANALYTICS = 'analytics/getOrganizationsAnalytics';

export interface IOrganizationAnalyticsItem {
  orgId: string;
  orgName: string;
}

interface IOrganizationsAnalyticsState {
  status: string;
  error: string | null;
  totalOrgCount: number;
  invitedOrgCount: number;
  disabledOrgCount: number;
  activeOrgCount: number;
  organizations: IOrganizationAnalyticsItem[];
}

const initialState: IOrganizationsAnalyticsState = {
  status: Status.IDLE,
  error: null,
  totalOrgCount: 0,
  invitedOrgCount: 0,
  disabledOrgCount: 0,
  activeOrgCount: 0,
  organizations: [],
};

export const getOrganizationsAnalytics = createAsyncThunk(
  GET_ORGANIZATIONS_ANALYTICS,
  async () => {
    const organizationsAnalyticsResponse = await getOrganizationsAnalyticsApi();
    return normalizeOrganizationsAnalyticsResponse(organizationsAnalyticsResponse);
  }
);

const organizationsAnalyticsSlice = createSlice({
  name: 'organizationsAnalytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationsAnalytics.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(getOrganizationsAnalytics.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.error = null;
        state.totalOrgCount = action.payload.totalOrgCount;
        state.invitedOrgCount = action.payload.invitedOrgCount;
        state.disabledOrgCount = action.payload.disabledOrgCount;
        state.activeOrgCount = action.payload.activeOrgCount;
        state.organizations = action.payload.organizations;
      })
      .addCase(getOrganizationsAnalytics.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          action.error.message || 'Failed to fetch organizations analytics.';
      });
  },
});

export const selector = (state: RootState) => state.organizationsAnalytics;

export default organizationsAnalyticsSlice.reducer;